import SelectInput from "./SelectInput";
export default SelectInput;
